<div class="dialog-title">
  <h2 class="title">
    <mat-icon>devices_other</mat-icon>
    {{'datatable.units'|translate}}
  </h2>

  <span class="spacer"></span>

  <app-search-bar (searchText)="search($event)"></app-search-bar>


  <lib-button [matMenuTriggerFor]="menu" icon="more_vert" color="none" textColor="neutral" tooltip="Options">
  </lib-button>

  <mat-menu #menu="matMenu">
    <mat-checkbox class="filter-checkbox-disconnect" [(ngModel)]="showDisconnectTrackers">
      {{'viewer.showDisconnect' | translate}}
    </mat-checkbox>

    <button mat-menu-item class="menu-item" (click)="addResource()">
      <mat-icon color="primary">devices_other</mat-icon>
      <span>{{'units.add_unit' | translate}}</span>
    </button>

    <button mat-menu-item class="menu-item" (click)="addVirtualResource()">
      <mat-icon color="primary">wifi</mat-icon>
      <span>{{'units.add_virtual_unit' | translate}}</span>
    </button>
  </mat-menu>

  <lib-button (click)="close()" icon="close" color="none" textColor="muted" tooltip="{{'form.close'|translate}}">
  </lib-button>
</div>

<mat-dialog-content>
  <table mat-table [dataSource]="units" matSort>

    <!-- status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="space-cell">
        <div class="header-table">
          <mat-icon fontIcon="wifi"></mat-icon>
          {{'datatable.status'|translate}}
        </div>
      </th>

      <td mat-cell *matCellDef="let row" class="color-cell">
        <div class="connect">
          <div class="status-led" [ngClass]="!row.trackers || row.trackers.length === 0 ? 'gray' : row.colorName"></div>
        </div>
      </td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-table">
          <mat-icon fontIcon="devices"></mat-icon>
          {{'datatable.name'|translate}}
        </div>
      </th>

      <td mat-cell *matCellDef="let row">
        <p><b>{{row.name}}</b></p>

        <p *ngIf="row.trackers && row.trackers.length > 0" class="tracker-info">
          <mat-icon fontIcon="track_changes"></mat-icon> {{row.trackers[0]?.name}}
        </p>

        <p *ngIf="!row.trackers || row.trackers.length === 0" class="tracker-info no-tracker">
          {{'units.no_tracker_linked'|translate}}
        </p>
      </td>
    </ng-container>

    <!-- show Column -->
    <ng-container matColumnDef="show">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-table">
          <mat-checkbox type="checkbox" [checked]="show" (change)="showAll($event)"></mat-checkbox>

          <mat-icon fontIcon="visibility"></mat-icon>
          {{'datatable.visible'|translate}}
        </div>
      </th>

      <td mat-cell *matCellDef="let row">
        <mat-checkbox type="checkbox" [checked]="row.trackers && row.trackers.length > 0 && row.visible"
          [disabled]="!row.trackers || row.trackers.length === 0" (change)="showUnits($event,row.id,'show')">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- collider Column -->
    <ng-container matColumnDef="collider">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-table">
          <mat-checkbox type="checkbox" [checked]="showCollider" (change)="showAll($event,'showCollider')">
          </mat-checkbox>

          <mat-icon fontIcon="sports_kabaddi"></mat-icon>
          {{'datatable.collider'|translate}}
        </div>
      </th>

      <td mat-cell *matCellDef="let row">
        <mat-checkbox type="checkbox" [checked]="row.collider?.visible"
          [disabled]="!row.trackers || row.trackers.length === 0" (change)="showUnits($event,row.id,'showCollider')">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- trace Column -->
    <ng-container matColumnDef="trace">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-table">
          <mat-checkbox type="checkbox" [checked]="trace" (change)="showTrace($event)"></mat-checkbox>
          <mat-icon fontIcon="timeline"></mat-icon>
          {{'datatable.trace'|translate}}
        </div>
      </th>

      <td mat-cell *matCellDef="let row">
        <mat-checkbox [checked]="row.trackers && row.trackers.length > 0 && row.trace"
          [disabled]="!row.trackers || row.trackers.length === 0" (change)="showUnits($event,row.id,'trace')"
          class="space-checkbox">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- color Column -->
    <ng-container matColumnDef="color">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-table">
          <mat-icon fontIcon="palette"></mat-icon>
          {{'datatable.color'|translate}}
        </div>
      </th>

      <td mat-cell *matCellDef="let row">
        <mat-select [(value)]="row.color" *ngIf="row.trackers && row.trackers.length > 0"
          (selectionChange)="setUnitColor($event, row.id)" class="color-select">
          <mat-select-trigger>
            <div class="color-option">
              <span class="color-circle" [style.background-color]="getColorValue(row.color)"></span>
              <span class="color-name">{{getColorName(row.color)}}</span>
            </div>
          </mat-select-trigger>

          <mat-option *ngFor="let color of listColor" [value]="color.value">
            <div class="color-option">
              <span class="color-circle" [style.background-color]="color.value"></span>
              <span class="color-name">{{color.name}}</span>
            </div>
          </mat-option>
        </mat-select>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
        </lib-no-data>
      </td>
    </tr>
  </table>

  <div class="accuracy-group" id="load-traces" *ngIf="mode=='replay'">
    <div class="title">
      <mat-icon fontIcon="timeline"></mat-icon>
      <h4>{{'viewer.load_all_traces' | translate}}</h4>
    </div>

    <div class="input-group">
      <div class="btn input-group-addon btn-default">
        {{'viewer.trace_accuracy' | translate}} :
      </div>

      <mat-form-field appearance="outline" class="accuracy" subscriptSizing="dynamic">
        <mat-select [(ngModel)]="accuracy">
          <mat-option [value]="1">100%</mat-option>
          <mat-option [value]="2">80%</mat-option>
          <mat-option [value]="3">70%</mat-option>
          <mat-option [value]="4">60%</mat-option>
          <mat-option [value]="5">50%</mat-option>
          <mat-option [value]="6">40%</mat-option>
          <mat-option [value]="7">30%</mat-option>
          <mat-option [value]="8">20%</mat-option>
          <mat-option [value]="9">10%</mat-option>
        </mat-select>
      </mat-form-field>

      <lib-button color="muted" *ngIf="loadingTrace" loading="true"
        text="{{'status.loading' | translate}}"></lib-button>

      <lib-button color="primary" (click)="loadTraces()" *ngIf="!loadingTrace" icon="play_arrow"
        tooltip="{{'viewer.load_trace' | translate}}">
      </lib-button>

      <lib-button color="warning" (click)="clearTraces()" *ngIf="!loadingTrace" icon="stop"
        tooltip="{{'viewer.clear_trace' | translate}}">
      </lib-button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <lib-button text="{{'viewer.close'|translate}}" color="outline" icon="close" (click)="close()"></lib-button>
</mat-dialog-actions>